"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Popover_1 = __importDefault(require("../Popover/Popover"));
const SelectContext_1 = require("../../contexts/SelectContext");
const withJourney_1 = __importDefault(require("../../hocs/withJourney"));
const DrawerContext_1 = __importDefault(require("../../contexts/DrawerContext"));
const SelectDropdown = (props) => {
    const { isOpen, targetRef, onClose, closeOnBtnClick } = react_1.useContext(SelectContext_1.SelectContext);
    const { children } = props;
    const { inDrawer } = react_1.useContext(DrawerContext_1.default);
    if (inDrawer) {
        return (isOpen ? children : null);
    }
    return (react_1.default.createElement(Popover_1.default, Object.assign({ isOpen: isOpen, targetRef: targetRef, onClose: onClose, closeOnBtnClick: closeOnBtnClick }, props), children));
};
exports.default = withJourney_1.default('j-select-dropdown', SelectDropdown);
